import { fetchRequest } from './apiHelper';
export const queryResult = (job_id, apiServer, setResult) => {
  const url = `${apiServer}/smr_results/${job_id}.json`;

  fetchRequest(url)
    .then((data) => {
      switch (data.status) {
        case 'pending':
          setResult(data);
          setTimeout(() => queryResult(job_id, apiServer, setResult), 1000);
          break;
        case 'completed':
          const parsedResult = JSON.parse(data.result);
          const roundedRank = Math.floor(parsedResult.result * 10) / 10;
          const finalRank =
            parsedResult.result - roundedRank >= 0.05
              ? roundedRank + 0.1
              : roundedRank;
          const newData = {
            ...data,
            result: finalRank,
          };
          setResult(newData);
          break;
        default:
          setResult(data);
      }
    })
    .catch((err) => {
      setResult({ status: 'error', result: err.message });
    });
};
